import { Component, OnInit } from "@angular/core";
import { Sort } from "@angular/material/sort";
import { CommonService } from "src/app/services/common.service";
import { Prospects } from "src/app/shared/models/common.model";

@Component({
  selector: "app-prospects",
  templateUrl: "./prospects.component.html",
  styleUrls: ["./prospects.component.scss"],
})
export class ProspectsComponent implements OnInit {
  constructor(private _common: CommonService) {}

  prospectList: Prospects[];
  tempProspects: Prospects[];

  prospectTypes = [
    {
      viewValue: "Restaurants",
      value: "1",
    },
    {
      viewValue: "Drivers",
      value: "2",
    },
  ];

  ngOnInit(): void {
    this.getAllProspects();
  }

  getAllProspects(): void {
    this._common.get(`office/getAllProspects`).subscribe((resp: any) => {
      this.tempProspects = resp.data;
      this.filterProspects(1);
    });
  }

  filterProspects(type: string | number): void {
    this.prospectList = this.tempProspects.filter((v) => v.type == type);
  }

  sortData(sort: Sort): void {
    const data = this.prospectList.slice();
    if (!sort.active || sort.direction === "") {
      this.prospectList = data;
      return;
    }

    this.prospectList = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "id":
          return compare(a.indexId, b.indexId, isAsc);
        default:
          return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
